import React from 'react';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';

export const PhoneInputCustom = React.forwardRef(function PhoneInputCustom(props, ref) {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel htmlFor={props.id}>Telefone</InputLabel>
      <OutlinedInput {...props} inputRef={ref} label="Telefone" />
    </FormControl>
  );
});
